import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-public',
  imports: [RouterOutlet],
  templateUrl: './public.html',
  styleUrl: './public.scss',
})
export class Public {}
